export default __webpack_public_path__ + "static/media/bg_overlay.d734c09b.png";